export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_62e72119-8b96-442f-839f-e68de28582af/artifacts/dkgxwtwg_evser-hali-logo-header.png";

export const APP_VERSION = "1.9";

export const HERO_BG =
  "https://images.unsplash.com/photo-1600166898405-da9535204843?auto=format&fit=crop&w=2000&q=80";

export const ABOUT_IMG =
  "https://images.unsplash.com/photo-1631889993959-41b4e9c6e3c5?auto=format&fit=crop&w=1600&q=80";

export const TEXTURE_IMG =
  "https://images.unsplash.com/photo-1593510472612-b992b424f883?auto=format&fit=crop&w=1600&q=80";

export const ORDER_STATUSES = [
  "Yeni Sipariş",
  "İnceleniyor",
  "Onaylandı",
  "Hazırlanıyor",
  "Tamamlandı",
  "İptal Edildi",
];

export const STATUS_COLORS = {
  "Yeni Sipariş": "bg-blue-50 text-blue-800 border border-blue-200",
  İnceleniyor: "bg-amber-50 text-amber-800 border border-amber-200",
  Onaylandı: "bg-emerald-50 text-emerald-800 border border-emerald-200",
  Hazırlanıyor: "bg-violet-50 text-violet-800 border border-violet-200",
  Tamamlandı: "bg-stone-100 text-stone-900 border border-stone-300",
  "İptal Edildi": "bg-red-50 text-red-800 border border-red-200",
};

export const formatDate = (s) => {
  if (!s) return "—";
  try {
    const d = new Date(s);
    return d.toLocaleDateString("tr-TR", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return s;
  }
};

export const formatDateTime = (s) => {
  if (!s) return "—";
  try {
    const d = new Date(s);
    return d.toLocaleString("tr-TR", { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return s;
  }
};

export const fmtNum = (n, digits = 2) => {
  if (n == null) return "0";
  return Number(n).toLocaleString("tr-TR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: digits,
  });
};
